import { createCanvasContext2D } from "ol/dom.js";
import { equals, getHeight, getWidth } from "ol/extent.js";
import ImageCanvas from "ol/ImageCanvas.js";
import { Raster } from "ol/source";
import RasterEventType, { RasterSourceEvent } from "ol/source/Raster";

let sharedContext = null;

function getImageData(layer, frameState) {
  const renderer = layer.getRenderer();
  if (!renderer) {
    throw new Error('Unsupported layer type: ' + layer);
  }

  if (!renderer.prepareFrame(frameState)) {
    return null;
  }
  const width = frameState.size[0]*2; // hidpi mod
  const height = frameState.size[1]*2; // hidpi mod
  const container = renderer.renderFrame(frameState, null);
  let element;
  if (container) {
    element = container.firstElementChild;
  }
  if (!(element instanceof HTMLCanvasElement)) {
    throw new Error('Unsupported rendered element: ' + element);
  }
  if (element.width === width && element.height === height) {
    const context = element.getContext('2d');
    return context.getImageData(0, 0, width, height);
  }

  if (!sharedContext) {
    sharedContext = createCanvasContext2D(width, height);
  } else {
    const canvas = sharedContext.canvas;
    if (canvas.width !== width || canvas.height !== height) {
      sharedContext = createCanvasContext2D(width, height);
    } else {
      sharedContext.clearRect(0, 0, width, height);
    }
  }
  sharedContext.drawImage(element, 0, 0, width, height);
  return sharedContext.getImageData(0, 0, width, height);
}


export default class RasterHidpiSource extends Raster {
  constructor(options) {
    super(Object.assign({ pixelRatio: 2 }, options) );
    this.frameState_.pixelRatio = 2; // hidpi mod
  }

  processSources_() {
    const frameState = this.requestedFrameState_;
    const len = this.layers_.length;
    const imageDatas = new Array(len);
    for (let i = 0; i < len; ++i) {
      frameState.layerIndex = i;
      const imageData = getImageData(this.layers_[i], frameState); // hidpi getImageData
      if (imageData) {
        imageDatas[i] = imageData;
      } else {
        return;
      }
    }

    const data = {};
    super.dispatchEvent(new RasterSourceEvent(RasterEventType.BEFOREOPERATIONS, frameState, data));  // hidpi mod
    if (this.worker_) {
      this.worker_.process(imageDatas, data, this.onWorkerComplete_.bind(this, frameState));
    }
  }

  onWorkerComplete_(frameState, err, output, data) {

  if (err || !output) {
      return;
  }

  // do nothing if extent or resolution changed
  const extent = frameState.extent;
  const resolution = frameState.viewState.resolution;
  if (resolution !== this.requestedFrameState_.viewState.resolution ||
      !equals(extent, this.requestedFrameState_.extent)) {
      return;
  }

  let context;
  if (this.renderedImageCanvas_) {
      context = this.renderedImageCanvas_.getImage().getContext('2d');
  } else {
      const width = Math.round(getWidth(extent) / resolution) * frameState.pixelRatio; // hidpi mod
      const height = Math.round(getHeight(extent) / resolution) * frameState.pixelRatio; // hidpi mod
      context = createCanvasContext2D(width, height);
      this.renderedImageCanvas_ = new ImageCanvas(extent, resolution, 2, context.canvas);  // hidpi mod
  }
  context.putImageData(output, 0, 0);

  this.changed();
  this.renderedRevision_ = this.getRevision();

  this.dispatchEvent(new RasterSourceEvent(RasterEventType.AFTEROPERATIONS, frameState, data));
  }

}
